
import { create } from "zustand";

interface ClaimTypeState {
  claimType: string | null;
  setClaimType: (type: string) => void;
  resetClaimType: () => void;
}

export const useClaimTypeStore = create<ClaimTypeState>((set) => ({
  claimType: null,
  setClaimType: (type) => set({ claimType: type }),
  resetClaimType: () => set({ claimType: null }),
}));
